// This file contains the text data for the training sessions
export const TRAINING_DATA = {
    // Day 1 - Story 02 (Amusement Park) - 16 stimuli
    day1: [
        { id: "Trn_02_01", text: "Do you like amusement parks? Well, I sure do." },
        { id: "Trn_02_02", text: "To amuse myself, I went twice last spring." },
        { id: "Trn_02_03", text: "My most memorable moment was riding on the caterpillar." },
        { id: "Trn_02_04", text: "Which is a gigantic rollercoaster high above the ground." },
        { id: "Trn_02_05", text: "When I saw how high the Caterpillar rose into the bright blue sky, I knew it was for me." },
        { id: "Trn_02_06", text: "After waiting in line for thirty minutes, I made it to the front, where the man measured my height to see if I was tall enough." },
        { id: "Trn_02_07", text: "I gave the man my coins, asked for change, and jumped on the cart." },
        { id: "Trn_02_08", text: "Tick, tick, tick... The Caterpillar climbed slowly up the tracks." },
        { id: "Trn_02_09", text: "It went so high I could see the parking lot. Boy, I was scared." },
        { id: "Trn_02_10", text: "I thought to myself, \"There's no turning back now.\"" },
        { id: "Trn_02_11", text: "People were so scared." },
        { id: "Trn_02_12", text: "They screamed as we swiftly zoomed, fast, fast, and faster along the tracks" },
        { id: "Trn_02_13", text: "As quickly as it started, the Caterpillar came to a stop." },
        { id: "Trn_02_14", text: "Unfortunately, it was time to pack the car and drive home." },
        { id: "Trn_02_15", text: "That night, I dreamt of the wild ride on the Caterpillar" },
        { id: "Trn_02_16", text: "Taking a trip to the amusement park and riding on the Caterpillar was my most memorable moment ever!" }
    ],

    // Day 2 - Story 03 (Snowball the Cat) - 14 stimuli
    day2: [
        { id: "Trn_03_01", text: "Megan's cat, Snowball, loved to play in the garden." },
        { id: "Trn_03_02", text: "Every morning, Megan opened the back door, and Snowball dashed outside." },
        { id: "Trn_03_03", text: "The little cat chased butterflies, sniffed flowers, and climbed the old oak tree." },
        { id: "Trn_03_04", text: "Megan often called Snowball her \"explorer\" because she loved to investigate every corner of the yard." },
        { id: "Trn_03_05", text: "One day, a squirrel darted across the lawn. Snowball froze." },
        { id: "Trn_03_06", text: "The squirrel stopped too, holding an acorn in its tiny paws." },
        { id: "Trn_03_07", text: "Megan watched from the window, curious to see what would happen." },
        { id: "Trn_03_08", text: "After a long pause, Snowball jumped forward, but the squirrel was faster." },
        { id: "Trn_03_09", text: "It ran up the tree and disappeared into the branches." },
        { id: "Trn_03_10", text: "Snowball meowed loudly, staring after it." },
        { id: "Trn_03_11", text: "A moment later, she darted back to Megan and curled up in her lap, playing with her blanket." },
        { id: "Trn_03_12", text: "Megan laughed and said, \"Your playfulness never ends, Snowball!\"" },
        { id: "Trn_03_13", text: "She patted her gently and added, \"Maybe next time you'll catch that squirrel.\"" },
        { id: "Trn_03_14", text: "Snowball purred contentedly, resting her head on Megan's arm." }
    ],

    // Day 3 - Story 04 (Jake at the Lake) - 12 stimuli
    day3: [
        { id: "Trn_04_01", text: "Every summer, Jake and his friends visited the lake near his grandfather's cabin." },
        { id: "Trn_04_02", text: "The water sparkled under the bright sun, and the tall trees swayed gently in the breeze." },
        { id: "Trn_04_03", text: "One afternoon, Jake decided to go fishing." },
        { id: "Trn_04_04", text: "He grabbed a rod, bait, and bucket, then walked to the dock." },
        { id: "Trn_04_05", text: "Sitting quietly, he cast his line into the water and waited and waited and waited." },
        { id: "Trn_04_06", text: "Suddenly, the rod jerked. Jake pulled hard, and a shiny fish wriggled at the end of the line." },
        { id: "Trn_04_07", text: "He shouted, \"I caught one!\" His friends ran over to see, cheering loudly." },
        { id: "Trn_04_08", text: "Jake carefully placed the fish in the bucket." },
        { id: "Trn_04_09", text: "\"Maybe next time, I'll catch a bigger one,\" he said with a grin." },
        { id: "Trn_04_10", text: "Later that day, Jake returned to the cabin and told his grandfather about the fish." },
        { id: "Trn_04_11", text: "His grandfather smiled and said, \"You've got the makings of a great fisherman!\"" },
        { id: "Trn_04_12", text: "Jake beamed proudly, excited to fish again tomorrow." }
    ],

    // Day 4 - Story 07 (Lucas with the Kite) - 14 stimuli
    day4: [
        { id: "Trn_07_01", text: "On a bright Saturday afternoon, Lucas went to the park with his family." },
        { id: "Trn_07_02", text: "As he walked through the grass, he saw a large, colorful kite soaring high in the sky." },
        { id: "Trn_07_03", text: "It was bright red with a long, yellow tail that flapped in the wind." },
        { id: "Trn_07_04", text: "Lucas watched in awe as the kite danced above the trees, its tail twisting and turning with each gust of wind." },
        { id: "Trn_07_05", text: "Curious, he walked closer and saw a boy standing near the edge of the field, holding the string of the kite." },
        { id: "Trn_07_06", text: "\"Want to give it a try?\" the boy asked, smiling." },
        { id: "Trn_07_07", text: "Lucas nodded eagerly, his heart racing with excitement." },
        { id: "Trn_07_08", text: "He gripped the string tightly as the wind tugged, lifting the kite even higher into the air." },
        { id: "Trn_07_09", text: "\"Hold it steady,\" the boy said, giving Lucas a few tips." },
        { id: "Trn_07_10", text: "As the kite soared gracefully, Lucas heard the chirping of birds and the sharp \"shh\" of the trees swaying in the breeze." },
        { id: "Trn_07_11", text: "Suddenly, a jet flew overhead with a loud \"whoosh, \" its engines roaring like thunder." },
        { id: "Trn_07_12", text: "\"That was amazing!\" Lucas exclaimed." },
        { id: "Trn_07_13", text: "The boy laughed and said, \"Come back tomorrow, and we can fly it again." },
        { id: "Trn_07_14", text: "We might even try a bigger kite and maybe chase a few more birds!\"" }
    ]
};

// DEPRECATED - No longer using fixed mapping
// Now using randomized stories for each user via randomizeTrainingStories() in randomization.js
// This is kept for backward compatibility reference only
export const TRAINING_DAY_TO_STORY = {
    1: "02", // Story 02 - Amusement Park (30 stimuli)
    2: "03", // Story 03 - Snowball the Cat (24 stimuli)
    3: "04", // Story 04 - Jake at the Lake (22 stimuli)
    4: "07"  // Story 07 - Lucas with the Kite (23 stimuli)
};

// Story metadata including their lengths
export const STORY_METADATA = {
    "02": { length: 16, title: "Amusement Park" },
    "03": { length: 14, title: "Snowball the Cat" },
    "04": { length: 12, title: "Jake at the Lake" },
    "07": { length: 14, title: "Lucas with the Kite" }
};

// Create test stimuli for each training day - 20 items per day
export const TRAINING_TEST_STIMULI = {
    day1: Array.from({ length: 20 }, (_, i) => ({
        id: `TrnTest_02_${String(i + 1).padStart(2, '0')}`,
        audioUrl: `/audio/training/test/day1/${String(i + 1).padStart(2, '0')}`,
        type: 'TrnTest',
        responseType: 'full-phrase',
        day: 1
    })),
    day2: Array.from({ length: 20 }, (_, i) => ({
        id: `TrnTest_03_${String(i + 1).padStart(2, '0')}`,
        audioUrl: `/audio/training/test/day2/${String(i + 1).padStart(2, '0')}`,
        type: 'TrnTest',
        responseType: 'full-phrase',
        day: 2
    })),
    day3: Array.from({ length: 20 }, (_, i) => ({
        id: `TrnTest_04_${String(i + 1).padStart(2, '0')}`,
        audioUrl: `/audio/training/test/day3/${String(i + 1).padStart(2, '0')}`,
        type: 'TrnTest',
        responseType: 'full-phrase',
        day: 3
    })),
    day4: Array.from({ length: 20 }, (_, i) => ({
        id: `TrnTest_07_${String(i + 1).padStart(2, '0')}`,
        audioUrl: `/audio/training/test/day4/${String(i + 1).padStart(2, '0')}`,
        type: 'TrnTest',
        responseType: 'full-phrase',
        day: 4
    }))
};